// extracted by mini-css-extract-plugin
export default {"wrap":"XF-z","fullWidth":"YF-z","hideOnDesktop":"ZF-z","content":"_F-z","hasOpenedNav":"aG-z","crumbsList":"bG-z","dropdownsWrap":"cG-z"};